import * as styles from '../create-segment.module.scss';
import * as React from 'react';
import { FormControl, InputLabel, makeStyles, MenuItem, Select, TextField } from '@material-ui/core';
import { colors } from '../../../theme/colors';
import clsx from 'clsx';

interface Props {
  name: string;
  description: string;
  shared: string;
  onNameChange: (name: string) => void;
  onDescriptionChange: (description: string) => void;
  onSharedChange: (shared: string) => void;
  isClonedSegment?: boolean;
}

const useStyles = makeStyles({
  inputs: {
    margin: '0 16px',
    '& .MuiInputLabel-asterisk': {
      color: colors.rustRed
    }
  },
  select: {
    minWidth: 160
  }
});

const EditSegmentDetails = ({
  name,
  description,
  shared,
  onNameChange,
  onDescriptionChange,
  onSharedChange,
  isClonedSegment
}: Props) => {
  const overrides = useStyles();

  return (
    <div className={styles.detailsSectionContent}>
      <TextField
        size="small"
        variant="outlined"
        label="Segment Name"
        id="segment-name"
        className={overrides.inputs}
        required
        value={name}
        onChange={(event) => {
          onNameChange(event.target.value);
        }}
        inputProps={{ maxLength: 100 }}
        autoFocus={isClonedSegment}
      />
      <TextField
        size="small"
        variant="outlined"
        label="Segment Description"
        id="segment-description"
        className={clsx(overrides.inputs, styles.descriptionField)}
        required
        value={description}
        onChange={(event) => {
          onDescriptionChange(event.target.value);
        }}
        inputProps={{ maxLength: 500 }}
      />
      <FormControl required size="small" variant="outlined" className={clsx(overrides.inputs, overrides.select)}>
        <InputLabel id="shared-select-label">Shared</InputLabel>
        <Select
          labelId="shared-select-label"
          id="shared-select"
          value={shared}
          onChange={(event) => onSharedChange(event.target.value as string)}
        >
          <MenuItem value="Share">Share</MenuItem>
          <MenuItem value="Do not share">Do not share</MenuItem>
        </Select>
      </FormControl>
    </div>
  );
};

export default EditSegmentDetails;
